export function detectNoticePlatform(nav=typeof navigator==='undefined'?{}:navigator){
 const ua=nav.userAgent||'';
 if(/Android/i.test(ua))return 'android';
 if(/iPhone|iPad|iPod/i.test(ua)||(/Macintosh|MacIntel/i.test(ua+' '+(nav.platform||''))&&nav.maxTouchPoints>1))return 'ios';
 return 'unknown';
}
